import * as Farm from './farm';
import * as FarmMetadata from './farm-metadata';
import * as Cycle from './cycle';
import * as Market from './market';
import * as Weather from './weather';
import * as Picture from './picture';
import * as Revenue from './revenue';
import * as EventData from './event-data';
import * as EventProp from './event-prop';
import * as EventMessage from './event-message';
import * as Calendar from './calendar';
import * as CalendarDay from './calendar-day';
import * as CalendarEvent from './calendar-event';
export const Container = {
    models: {
        farm: Farm.Options,
        farmMetadata: FarmMetadata.Options,
        cycle: Cycle.Options,
        market: Market.Options,
        weather: Weather.Options,
        picture: Picture.Options,
        revenue: Revenue.Options,
        eventData: EventData.Options,
        eventProp: EventProp.Options,
        eventMessage: EventMessage.Options,
        calendar: Calendar.Options,
        calendarDay: CalendarDay.Options,
        calendarEvent: CalendarEvent.Options
    }
};
